import { defineComponent as n, useId as d, createElementBlock as p, openBlock as u, mergeProps as c, unref as o, createElementVNode as s, normalizeClass as i, toDisplayString as m, renderSlot as f } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Nav/nav.js";
import { useOUIAProps as S } from "../../helpers/ouia.js";
const _ = ["aria-labelledby"], v = ["id"], P = /* @__PURE__ */ n({
  name: "PfNavGroup",
  __name: "NavGroup",
  props: {
    title: {},
    id: { default: () => d() },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(r) {
    const t = r, l = S({ id: t.ouiaId, safe: t.ouiaSafe });
    return (e, y) => (u(), p("section", c(o(l), {
      class: o(a).navSection,
      "aria-labelledby": e.id
    }), [
      s("h2", {
        id: e.id,
        class: i(o(a).navSectionTitle)
      }, m(e.title), 11, v),
      s("ul", {
        class: i(o(a).navList)
      }, [
        f(e.$slots, "default")
      ], 2)
    ], 16, _));
  }
});
export {
  P as default
};
